const css = `.HyXmNq__buttonBase{cursor:pointer;appearance:none;color:inherit;font:inherit;background:0 0;border:none;outline:none;margin:0;padding:0;line-height:normal}.HyXmNq__buttonBase:hover{background:inherit}.HyXmNq__buttonBase.HyXmNq__disabled{cursor:not-allowed;background:inherit;pointer-events:none}.HyXmNq__buttonBase::-moz-focus-inner{border:0;padding:0}@media print{.HyXmNq__buttonBase{display:none}}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"buttonBase":"HyXmNq__buttonBase","disabled":"HyXmNq__disabled"};
